import { post } from "../util/crmAxios";

//新增跟班试听
export const addFollowClassAudition = (params) => post('/erp/studentAudition/addFollowClassAudition', params);
//更新跟班试听
export const updateFollowClassAudition = (params) => post('/erp/studentAudition/updateFollowClassAudition', params);
//新增一对一试听
export const addPrivateAudition = (params) => post('/erp/studentAudition/addPrivateAudition', params);
//更新一对一试听
export const updatePrivateAudition = (params) => post('/erp/studentAudition/updatePrivateAudition', params);
//获取检查分析员信息
export const getCheckTeachers = (params) => post('/erp/teacher/getCheckTeachers', params);
//试听列表
export const selectStudentAudition = (params) => post('/erp/studentAudition/selectStudentAudition', params);
//查询试听详情
export const selectAuditionDetail = (params) => post('/erp/studentAudition/selectAuditionDetail', params);
//取消试听
export const cancelAudition = (params) => post('/erp/studentAudition/cancelAudition', params);
//到访试听
export const signAudition = (params) => post('/erp/studentAudition/signAudition', params);
//班级课次统计信息
export const getClassScheduleTotal = (params) => post('/erp/classschedule/getClassScheduleTotal', params);
//学习机试听v2
export const addLearnMachineAuditionv2 = (params) => post('/erp/studentAudition/addLearnMachineAuditionv2', params);
// 新增单个学员教师关系
export const opSingleRelationV2 = (params) => post('/erp/relation/opSingleRelationV2', params);
//学习机试听
export const addAgentCustomInvite = (params) => post('/crm/invite/addAgentCustomInvite', params);

//学习机试听列表
export const queryStudentLearnMachineAuditio = (params) => post('/erp/studentAudition/queryStudentLearnMachineAuditio', params);
//学习机试听状态变更
export const setAuditionStatus = (params) => post('/erp/studentAudition/setAuditionStatus', params);

